<template>
  <BaseModal class="base-overlay-first main-base-modal-first">
    <div class="modal">
      <div class="modal__container">
        <div class="modal__title-container">
          <p class="modal__title typography__headline3">{{ t("rates.migrationModalTitle") }}</p>
          <p class="modal__additional typography__body2">{{ t("rates.migrationModalDescription") }}</p>
        </div>

        <BaseForm
          class="modal__container"
          has-enter-submit
          @submit="(event) => handleSubmit(event)"
        >
          <div class="modal__wrapper">
            <BaseInput2
              v-model="fields.name[0].value"
              v-bind="fields.name[1].value"
              class="base-input-first"
              :error="errors.name"
              name="name"
              :placeholder="t('pages.client.contacts.inputs.name.placeholder')"
            />

            <BaseInput2
              v-model="fields.nickname[0].value"
              v-bind="fields.nickname[1].value"
              class="base-input-first"
              :error="errors.nickname"
              name="nickname"
              :placeholder="t('pages.client.contacts.inputs.nickname.placeholder')"
            />

            <BasePhoneInput
              v-model="fields.phone[0].value"
              class="base-input-first"
              :error="errors.phone"
              name="phone"
              :placeholder="t('pages.client.contacts.inputs.phone.placeholder')"
            />

            <div style="width: 100%">
              <BaseTextarea2
                v-model="fields.question[0].value"
                v-bind="fields.question[1].value"
                class="base-textarea-first"
                :error="errors.question"
                name="question"
                :placeholder="t('pages.client.contacts.inputs.injury.placeholder')"
                autoresize
              />
            </div>
          </div>

          <div class="modal__buttons">
            <BaseButton2
              class="base-button-extra-big base-button-first base-button-round modal__button"
              class-loader="base-loader-second"
              :loading
              type="submit"
            >
              {{ t("pages.client.contacts.inputs.submitButton") }}
            </BaseButton2>
          </div>
        </BaseForm>
      </div>
    </div>
  </BaseModal>
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { client } = useClientStore();
const { errors, fields, handleSubmit, loading } = useMakeContactOrderForm(client.value, "data transfer");
</script>

<style scoped>
.modal {
  display: flex;
  flex-direction: column;
  row-gap: 32px;
}

.modal__title-container {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.modal__title {
  color: var(--grey-1-5);
}

.modal__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 12px;
}

.modal__additional {
  color: var(--grey-3);
}

.modal__container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.modal__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 16px;
}

.modal__button {
  width: 100%;
}
</style>
